/**
 * Faceted Search - Async
 */

(() => {
    let form = document.querySelector('.js-faceted-search-form');
    let submit_button = document.querySelector(
        '.js-faceted-search-submit-button'
    );

    if (!form || !submit_button) {
        return;
    }

    function hideOverlay() {
        // console.log('Hiding overlay...');
        // prettier-ignore
        document.querySelector('.js-faceted-search-results-overlay')?.classList.add('-hidden'); // jshint ignore:line
    }

    function showOverlay() {
        // console.log('Showing overlay...');
        // prettier-ignore
        document.querySelector('.js-faceted-search-results-overlay')?.classList.remove('-hidden'); // jshint ignore:line
    }

    function setHistory() {
        // console.log('Setting history...');

        const formData = new FormData(form);
        let search = new URLSearchParams(formData);
        search.delete('override-page'); // remove override-page -parameter
        const query = search.toString();
        const url = '?' + query;

        // console.log('url', url);

        window.history.replaceState(null, '', url);
    }

    function isEventForLoadMoreButton(e) {
        return e.target.classList.contains(
            'js-htmx-faceted-search-load-more-button'
        );
    }

    function init() {
        form.addEventListener('htmx:beforeRequest', (e) => {
            if (isEventForLoadMoreButton(e)) {
                return;
            }

            showOverlay();
        });
        form.addEventListener('htmx:afterOnLoad', (e) => {
            if (isEventForLoadMoreButton(e)) {
                return;
            }

            window.sticky_header_tools?.makeBackwardsFocusable(
                document.querySelector('#search-results')
            );
            setHistory();
            hideOverlay();
        });
    }

    init();
})();
